import * as Application from 'expo-application'
import Constants from 'expo-constants'
import { Box, Text } from 'native-base'
import React from 'react'

import {
  API_URL,
  APP_URL,
  CLIENT_ID,
  DESIGN_SYSTEM_THEME,
  ENVIRONMENT,
  MERCADO_PAGO_API_URL,
  NODE_CONFIG_ENV,
  STRAPI_API_URL,
} from '../constants/config'
import { isiOS, isWeb } from '../util/platform'

export function ShowEnvironmentVariables() {
  if (isWeb()) {
    return null
  }

  if (!ENVIRONMENT || ENVIRONMENT.includes('prod')) {
    return null
  }

  return <ShowEnvironmentVariablesInternal />
}

function ShowEnvironmentVariablesInternal() {
  const [releaseType, setReleaseType] = React.useState<string>()

  React.useEffect(() => {
    if (isiOS()) {
      Application.getIosApplicationReleaseTypeAsync()
        .then((releaseTypeValue: Application.ApplicationReleaseType) => {
          const releaseTypeKey = Application.ApplicationReleaseType[releaseTypeValue]
          setReleaseType(releaseTypeKey)
        })
        .catch()
    }
  }, [])

  return (
    <Box p={4}>
      <Text>{`Application ID: ${Application.applicationId}`}</Text>
      <Text>{`Application name: ${Application.applicationName}`}</Text>
      <Text>{`Native application version: ${Application.nativeApplicationVersion}`}</Text>
      <Text>{`Native application build: ${Application.nativeBuildVersion}`}</Text>
      {releaseType ? <Text>{`iOS release type: ${releaseType}`}</Text> : null}
      <Text bold my={3}>
        --- Environment variables ---
      </Text>
      <Text>{`ENVIRONMENT: ${ENVIRONMENT}`}</Text>
      <Text>{`NODE_CONFIG_ENV: ${NODE_CONFIG_ENV}`}</Text>
      <Text>{`DESIGN_SYSTEM_THEME: ${DESIGN_SYSTEM_THEME}`}</Text>
      <Text>{`APP_URL: ${APP_URL}`}</Text>
      <Text>{`API_URL: ${API_URL}`}</Text>
      <Text>{`STRAPI_API_URL: ${STRAPI_API_URL}`}</Text>
      <Text>{`CLIENT_ID: ${CLIENT_ID}`}</Text>
      <Text>{`MERCADO_PAGO_API_URL: ${MERCADO_PAGO_API_URL}`}</Text>
      <Text bold my={3}>
        --- Constants.manifest ---
      </Text>
      <Text>{`owner: ${Constants.manifest?.owner}`}</Text>
      <Text>{`slug: ${Constants.manifest?.slug}`}</Text>
      <Text>{`version: ${Constants.manifest?.version}`}</Text>
      <Text>{`Android versionCode: ${Constants.manifest?.android?.versionCode}`}</Text>
      <Text>{`iOS buildNumber: ${Constants.manifest?.ios?.buildNumber}`}</Text>
      <Text>{`eas: ${JSON.stringify(Constants.manifest?.extra?.eas, null, 2)}`}</Text>
      <Text>{`extra.DESIGN_SYSTEM_THEME: ${JSON.stringify(
        Constants.manifest?.extra?.DESIGN_SYSTEM_THEME,
        null,
        2
      )}`}</Text>
      <Text>{`extra.ENVIRONMENT: ${JSON.stringify(Constants.manifest?.extra?.ENVIRONMENT, null, 2)}`}</Text>
      <Text>{`android.package: ${JSON.stringify(Constants.manifest?.android?.package, null, 2)}`}</Text>
      <Text>{`ios.bundleIdentifier: ${JSON.stringify(Constants.manifest?.ios?.bundleIdentifier, null, 2)}`}</Text>
    </Box>
  )
}
